import { CustomErrorMessage } from '@src/design-system/error-message';
import { ErrorMessage, Form } from 'formik';
import FileUpload from '@src/design-system/molecules/file-upload';
import { DocumentUpload } from 'iconsax-react';
import { uploadMedia } from '@src/shared/utils/media-utils/upload-media';
import type { TUniversityPayload } from '@src/features/universities/services/universities-api';
import type { TImage } from '@src/shared/types/image';
import { FileUploaded } from '@src/features/placements/pages/create/file-uploaded';
import { useFormikContext } from 'formik';

const UniversityLogo = () => {
  const { values, setFieldValue } = useFormikContext<TUniversityPayload>();

  return (
    <Form>
      <div className='space-y-4 border border-gray-200 rounded-[12px] p-4'>
        <div className='flex items-center gap-2'>
          <DocumentUpload
            size={24}
            className='text-gray-900'
          />
          <label className='text-gray-900 font-medium'>Upload Logo</label>
        </div>
        {values.logo ? (
          <FileUploaded
            viewOnly
            onDelete={() => setFieldValue('logo', undefined)}
            file={values.logo as TImage}
            progressValue={0}
            values={[]}
            fieldName='logo'
          />
        ) : (
          <FileUpload
            name='logo'
            onChange={(file) => {
              if (!file) return;
              uploadMedia(file).then((response) => {
                if (response) setFieldValue('logo', response);
              });
            }}
            allowedFormats='.jpg, .png, .svg, .zip'
            maxSize='800x400px'
            maxFileSizeMB={10}
            note='Only support .jpg, .png and .svg and zip files'
          />
        )}
        <ErrorMessage
          name='logo'
          component={CustomErrorMessage}
        />
      </div>
    </Form>
  );
};

export default UniversityLogo;
